<template>
    <ul class="navbar-nav" role="nav">
        <slot />
    </ul>
</template>

<script>
export default {

    name: 'NavbarNav'

};
</script>
